/* AT-NAV-INTENT v1.1 (AT-NAV-HOVER-001, 2026-09-24): hover intent for the Horizon header menu, applied to the live <header-menu> instance
   (no theme file touched). Horizon opens a menu on pointerenter and closes it on the very first pointerleave; in the More panel the labels sit
   in a left column and their options on the right, so a diagonal move toward the options crosses the next label and swaps or empties the
   options before they can be clicked. Here: (1) close grace — leaving the menu closes it only after 420 ms off the menu; (2) menu aim — while
   the pointer travels from the open item toward its options, other labels it crosses do not take over; they take over only when the pointer
   rests on them (220 ms) or stays on them 900 ms; (3) the More panel's own pointerleave gets the same grace. Keyboard focus/blur and touch
   input keep the theme's original behaviour. v1.1: hover is read by a fresh hit test at the pointer (browsers keep a stale :hover after the
   theme's safety box hides), so a deliberate move to a second-row label (two-row header, AT-NAV-WRAP-001) takes over after a short rest. */
(function () {
  if (window.AT_NAV_INTENT) return;
  var GRACE = 420, REST = 220, MAXW = 900, PAD = 14;
  var PT = { x: -1, y: -1 }, LAST_MOVE = 0;
  function now() { return Date.now(); }
  function inRect(p, r) { return p.x >= r.left && p.x <= r.right && p.y >= r.top && p.y <= r.bottom; }
  function sg(a, b, c) { return (a.x - c.x) * (b.y - c.y) - (b.x - c.x) * (a.y - c.y); }
  function inTri(p, a, b, c) { var d1 = sg(p, a, b), d2 = sg(p, b, c), d3 = sg(p, c, a); return !((d1 < 0 || d2 < 0 || d3 < 0) && (d1 > 0 || d2 > 0 || d3 > 0)); }
  function inHull(p, o, r) {
    if (inRect(p, r)) return true;
    var c = [{ x: r.left, y: r.top }, { x: r.right, y: r.top }, { x: r.right, y: r.bottom }, { x: r.left, y: r.bottom }];
    for (var i = 0; i < 4; i++) if (inTri(p, o, c[i], c[(i + 1) % 4])) return true;
    return false;
  }
  function vis(el) { if (!el) return false; var r = el.getBoundingClientRect(); return r.width > 0 && r.height > 0 && getComputedStyle(el).visibility !== 'hidden'; }
  function union(els) {
    var r = null;
    [].forEach.call(els, function (e) { if (!vis(e)) return; var b = e.getBoundingClientRect(); if (!r) r = { left: b.left, top: b.top, right: b.right, bottom: b.bottom }; else { r.left = Math.min(r.left, b.left); r.top = Math.min(r.top, b.top); r.right = Math.max(r.right, b.right); r.bottom = Math.max(r.bottom, b.bottom); } });
    return r;
  }
  function grow(r, n) { return r ? { left: r.left - n, top: r.top - n, right: r.right + n, bottom: r.bottom + n } : null; }
  function isTouch(ev) { try { return ev && ev.pointerType === 'touch'; } catch (e) { return false; } }
  function isFocus(ev) { try { return typeof FocusEvent !== 'undefined' && ev instanceof FocusEvent; } catch (e) { return false; } }

  function patch(hm) {
    if (!hm || hm.__atNav) return true;
    if (typeof hm.activate !== 'function' || typeof hm.deactivate !== 'function') return false;
    hm.__atNav = 'v1.1';
    var A = hm.activate, D = hm.deactivate;
    var active = null, anchor = null, pend = null, pendT0 = 0, pendIv = 0, closeT = 0;
    function isOpen() { return hm.getAttribute('aria-expanded') === 'true' || !!hm.querySelector('[ref="menuitem"][aria-expanded="true"]'); }
    function ov() { try { return hm.overflowMenu || null; } catch (e) { return null; } }
    function under() { if (PT.x < 0) return null; try { return document.elementFromPoint(PT.x, PT.y); } catch (e) { return null; } }
    function inEl(li) { var e = under(); return !!(e && li && (li === e || li.contains(e))); }
    function hov(el) { try { return !!el && el.matches(':hover'); } catch (e) { return false; } }
    function linkRect(li) { var a = li && li.querySelector('[ref="menuitem"]'); var r = (a || li).getBoundingClientRect(); return grow({ left: r.left, top: r.top, right: r.right, bottom: r.bottom }, 2); }
    var RC = null, RCt = 0, RCa = null;
    function target() { var t = now(); if (RCa === active && t - RCt < 120) return RC; RCa = active; RCt = t; RC = measure(); return RC; }
    function measure() {
      var li = active; if (!li) return null;
      if (li.getAttribute('slot') === 'more') { var o = ov(); var ls = o && o.querySelector('[part="overflow-list"]'); return ls ? grow(ls.getBoundingClientRect(), PAD) : null; }
      var sub = li.querySelector('.menu-list__submenu'); if (!sub) return null;
      return grow(union(sub.querySelectorAll('a')) || (vis(sub) ? sub.getBoundingClientRect() : null), PAD);
    }
    function onActive() { if (!active || PT.x < 0) return false; if (inRect(PT, linkRect(active))) return true; var R = target(); return !!(R && inRect(PT, R)); }
    function stopPend() { pend = null; if (pendIv) { clearInterval(pendIv); pendIv = 0; } }
    function commit(li, ev) {
      stopPend(); active = li; RCa = null;
      try { A.call(hm, ev && ev.target === li ? ev : { target: li, type: 'pointerenter' }); } catch (e) {}
      if (PT.x >= 0) anchor = { x: PT.x, y: PT.y };
    }
    function tick() {
      if (!pend) return stopPend();
      if (!isOpen()) { var l0 = pend; stopPend(); if (inEl(l0)) commit(l0); return; }
      if (onActive()) return stopPend();
      if (!inEl(pend)) return stopPend();
      var t = now();
      if (t - LAST_MOVE >= REST || t - pendT0 >= MAXW) { var l = pend; commit(l); }
    }
    function act(ev) {
      var li = ev && ev.target;
      if (closeT) { clearTimeout(closeT); closeT = 0; }
      if (!(li instanceof Element) || isFocus(ev) || isTouch(ev)) { stopPend(); if (li instanceof Element) active = li; return A.call(hm, ev); }
      if (!isOpen() || !active || !active.isConnected) { commit(li, ev); return; }
      if (li === active) { stopPend(); return A.call(hm, ev); }
      if (active.getAttribute('slot') === 'more' && li.getAttribute('slot') === 'overflow') { commit(li, ev); return; }
      var R = target();
      if (R && anchor && PT.x >= 0 && inHull(PT, anchor, R)) {
        if (pend !== li) { pend = li; pendT0 = now(); }
        if (!pendIv) pendIv = setInterval(tick, 40);
        return;
      }
      commit(li, ev);
    }
    function inMenu() {
      try {
        var e = under(); if (!e) return false;
        var li = e.closest ? e.closest('.menu-list__list-item') : null; if (li && hm.contains(li)) return true;
        var o = ov(); if (o && isOpen() && hm.contains(e) && !li) { var r = o.getBoundingClientRect(); if (r.height > 0 && inRect(PT, r)) return true; }
        var R = target(); return !!(R && inRect(PT, R));
      } catch (e) { return false; }
    }
    function scheduleClose() {
      if (closeT) clearTimeout(closeT);
      closeT = setTimeout(function () {
        closeT = 0;
        if (inMenu()) return;
        stopPend();
        var li = active; active = null; anchor = null;
        if (isOpen()) { try { D.call(hm, { target: li || hm, relatedTarget: null, type: 'pointerleave' }); } catch (e) {} }
      }, GRACE);
    }
    function deact(ev) {
      if (!ev || ev.type === 'blur' || isTouch(ev)) { stopPend(); return D.call(hm, ev); }
      scheduleClose();
    }
    hm.activate = act;
    hm.deactivate = deact;
    function hookOv() {
      var o = ov(); if (!o || o.__atNav) return;
      o.__atNav = 1;
      o.addEventListener('pointerleave', function (e) { if (isTouch(e)) return; e.stopImmediatePropagation(); scheduleClose(); }, true);
    }
    hookOv(); setTimeout(hookOv, 1500);
    document.addEventListener('pointermove', function (e) {
      if (e.pointerType === 'touch') return;
      var dx = e.clientX - PT.x, dy = e.clientY - PT.y;
      if (dx * dx + dy * dy >= 4) LAST_MOVE = now();
      PT.x = e.clientX; PT.y = e.clientY;
      if (active && isOpen() && onActive()) { anchor = { x: PT.x, y: PT.y }; if (pend) stopPend(); }
    }, { passive: true, capture: true });
    return true;
  }
  function run() { var ok = false; [].forEach.call(document.querySelectorAll('header-menu'), function (h) { ok = patch(h) || ok; }); return ok; }
  window.AT_NAV_INTENT = { version: 'v1', run: run };
  function boot() {
    if (run()) return;
    try { if (window.customElements && customElements.whenDefined) customElements.whenDefined('header-menu').then(function () { setTimeout(run, 0); }); } catch (e) {}
    var n = 0, iv = setInterval(function () { if (run() || ++n > 60) clearInterval(iv); }, 250);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
